// Max length for user first name / second name input fields.
export const USER_NAME_MAX_LENGTH = 30;

// Max length for the phone / contact field on the profile.
export const USER_PHONE_MAX_LENGTH = 20;

// Max length for the denomination (church) name.
export const USER_DENOMINATION_MAX_LENGTH = 100;

/* Free-text limits. Generous enough that nobody writing in good faith meets them —
   the point is the accidental paste of a whole document into a review box, not a
   determined sender, who bypasses the form anyway. The server accepts any length
   today, so these are a courtesy to the writer, not a guarantee. */
export const FEEDBACK_MAX_LENGTH = 2000;
export const LESSON_ANSWER_MAX_LENGTH = 5000;
